import React, { Component } from 'react'
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { Button, Col, Input, Row } from 'antd';
import { spacing } from '../../lib/theme';
import { secToDateDay } from '../../lib/utils';
import { fetchReviewReplies } from '../../actions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import AddReply from './AddReply';
import ReviewReplyOptions from './ReviewReplyOptions';
import ReplyReport from './ReplyReport';

class ReviewReply extends Component {
    constructor(props) {
        super(props);
        this.state = { addingReply: false, editingReply: false };
    }

    componentDidMount() {
        const { review } = this.props;
        // this.props.fetchReviewReplies(review);
    }

    addReply = () => {
        this.setState({ addingReply: true });
    }

    closeAddReply = () => {
        this.setState({ addingReply: false, editingReply: false });
    }

    editReviewCommentChild = () => {
        this.setState({ editingReply: true });
    }

    render() {
        const { commentId, comment, review, userDetails } = this.props;
        const { addingReply, editingReply } = this.state;
        const user = comment.user || {};
        const currentUserUID = userDetails && userDetails.uid;
        // console.dir(commentId);

        const replyIndentations = (commentId.match(/-/g) || []).length;
        // console.dir(replyIndentations);

        // if (comment.deletedTime) {
        //     return 
        // }
        const reportedArray = comment.reportedArray || [];
        const alreadyReported = userDetails.uid && (reportedArray.includes(userDetails.uid));

        return (
            <div className='review-reply' style={{ marginBottom: `${spacing('md')}`, paddingLeft: `calc(${replyIndentations}*${spacing('lg')})` }}>
                {comment.deletedTime ? <h5>This comment has been deleted</h5> :
                    <>
                        {editingReply ? <AddReply type='commentReply' commentId={commentId} comment={comment} review={review} closeAddReply={this.closeAddReply} /> :
                            <>
                                <div style={{
                                    display: 'flex',
                                    // alignItems: 'center'
                                }}>
                                    <h4>{user.name} {(user.id == currentUserUID) && '(Me)'}</h4>
                                    &nbsp;&nbsp;&middot;&nbsp;
                                    <h5 style={{ transform: 'translate(0, 2px)' }}>&nbsp; {secToDateDay(comment.postedTime && comment.postedTime / 1000)} {comment.modifiedTime && ' (edited)'}</h5>
                                    {(user.id == currentUserUID) && <div className=''>
                                        <ReviewReplyOptions commentId={commentId} review={review} editReviewCommentParent={this.editReviewCommentChild} />
                                    </div>}
                                </div>
                                <p style={{ marginBottom: `${spacing('sm')}` }}>{comment.comment}</p>
                            </>
                        }
                        {/* <Button onClick={this.addReply} type="link">Reply</Button> */}
                        <div style={{ display: 'flex' }}>
                            <a onClick={this.addReply}>
                                <FontAwesomeIcon icon='reply' /> Reply</a>
                            <div className='reply-options' style={{
                                position: 'absolute',
                                right: '0'
                            }}>
                                <ReplyReport commentId={commentId} comment={comment} review={review} />
                            </div>
                        </div>
                        {addingReply && <AddReply type='commentReply' commentId={commentId} review={review} closeAddReply={this.closeAddReply} />}
                    </>
                }
                <style jsx>
                    {`
                        .reply-options {
                            display: ${!alreadyReported && reportedArray.length < 1 ? 'none' : 'block'};
                        }
                        .review-reply:hover .reply-options {
                            display: block;
                        }
                    `}
                </style>
            </div>
        )
    }
}

ReviewReply.propTypes = {
    userDetails: PropTypes.object,
    comment: PropTypes.object,
    commentId: PropTypes.string,
    review: PropTypes.object,
}

const mapStateToProps = (state) => {
    return {
        userDetails: state.userDetails,
        loadingState: state.loadingState,
        reviewReplies: state.reviewRepliesState,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        // replyReview: bindActionCreators(replyReview, dispatch),
        fetchReviewReplies: bindActionCreators(fetchReviewReplies, dispatch),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(ReviewReply);